import { DotLegalPrettyScrollbar } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import CommentCard from "../commentCard/CommentCard";
import { CommentViewModel } from "../commentCard/CommentCard.types";

export interface ICommentTrack {
    data: Array<CommentViewModel> | undefined;
    scrollToBottomOnNewComment?: boolean;
    maxHeight: string | number;
    commentIdToScroll?: string;
    disableOverflowMenu: boolean;
    onDeleteComment: (commentId: string) => void;
    onDeleteSubComment: (commentId: string, subCommentId: string) => void;
    onPinClick?: (isPinned: boolean, commentId: string) => void;
    onEditComment: (commentId: string, content: string, pinned: boolean) => void;
    onEditSubComment: (commentId: string, subCommentId: string, content: string) => void;
    onReplyToComment: (commentId: string) => void;
    applyMarkup?: boolean;
}

function CommentTrack(props: ICommentTrack) {
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.commentIdToScroll) {
            setTimeout(() => {
                messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } else if (props.scrollToBottomOnNewComment) {
            setTimeout(() => {
                bottomRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
            }, 100);
        }
    }, [props.scrollToBottomOnNewComment, props.commentIdToScroll]);

    return (
        <DotLegalPrettyScrollbar>
            <Box sx={{ width: "100%" }}>
                {props.data?.map((comment, i) => {
                    return (
                        <React.Fragment key={comment.id}>
                            {props.commentIdToScroll === comment.id && <div ref={messagesEndRef}></div>}
                            <CommentCard
                                key={comment.id}
                                onDeleteClick={() => props.onDeleteComment(comment.id)}
                                comment={comment}
                                disableOverFlowMenu={props.disableOverflowMenu}
                                onReplyClick={() => {
                                    props.onReplyToComment(comment.id);
                                }}
                                isSubComment={false}
                                onEditClick={() => {
                                    props.onEditComment(comment.id, comment.content, comment.pinned ?? false);
                                }}
                                hasSubComments={comment.subComments.length > 0}
                                onPinClick={
                                    props.onPinClick
                                        ? (val: boolean) => {
                                              if (props.onPinClick) {
                                                  props.onPinClick(val, comment.id);
                                              }
                                          }
                                        : undefined
                                }
                                applyMarkDown={props.applyMarkup}
                            />
                            {comment.subComments.map((subComment, i) => {
                                return (
                                    <React.Fragment key={subComment.id}>
                                        {props.commentIdToScroll === subComment.id && <div ref={messagesEndRef}></div>}
                                        <CommentCard
                                            key={subComment.id}
                                            onDeleteClick={() => props.onDeleteSubComment(comment.id, subComment.id)}
                                            comment={subComment}
                                            disableOverFlowMenu={props.disableOverflowMenu}
                                            isSubComment
                                            onEditClick={() => {
                                                props.onEditSubComment(comment.id, subComment.id, subComment.content);
                                            }}
                                            hasSubComments={false}
                                        />
                                    </React.Fragment>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
                <div ref={bottomRef}></div>
            </Box>
        </DotLegalPrettyScrollbar>
    );
}

export default CommentTrack;
